module.exports = __webpack_public_path__ + "7ab23988da4e51f43ea0f99165c7dcac.pdf";